import React, { useEffect, useState } from "react";
import { IoIosSearch } from "react-icons/io";
import { PiDotsThreeVertical } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { FaUserTie } from "react-icons/fa";
import { NotificationAddRounded } from "@mui/icons-material";
import { db, realtimedb } from "../../../FirebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { onValue, ref as dbRef } from "firebase/database";

const sanitizeEmail = (email) => email.replace(/\./g, "_");

const EmployeeChat = () => {
  const user = JSON.parse(localStorage.getItem("admin"));
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  const handleUserClick = (email) => {
    navigate(`/chat/${email}`);
  };

  useEffect(() => {
    const fetchUsersWithLatestMessages = async () => {
      try {
        const snapshot = await getDocs(collection(db, "financeUserPortal"));
        const userList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const chatsRef = dbRef(realtimedb, "chats");

        onValue(chatsRef, (snap) => {
          const allChats = snap.val() || {};

          const enriched = userList.map((u) => {
            const chatId = [sanitizeEmail(user.email), sanitizeEmail(u.email)]
              .sort()
              .join("_");

            const messages = allChats[chatId]
              ? Object.values(allChats[chatId])
              : [];

            const lastTimestamp = messages.length
              ? Math.max(...messages.map((msg) => msg.timestamp || 0))
              : 0;

            const lastRead = localStorage.getItem(`lastRead_${chatId}`) || 0;

            const unreadCount = messages.filter(
              (msg) => msg.timestamp > lastRead && msg.sender !== user.email
            ).length;

            return {
              ...u,
              lastTimestamp,
              unreadCount,
            };
          });
          

          enriched.sort((a, b) => b.lastTimestamp - a.lastTimestamp);

          setUsers(enriched);
        });
      } catch (error) {
        console.error("Error fetching user list:", error);
      }
    };

    fetchUsersWithLatestMessages();
  }, []);

  return (
    <div
      style={{
        backgroundColor: "white",
        height: "100%",
        width: "100%",
        overflow: "hidden",
        marginRight: "10px",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "white",
          borderBottom: "1px solid gray",
          padding: "15px",
          fontSize: "20px",
        }}
      >
        <h5>All Chats</h5>
        <div style={{ display: "flex" }}>
          <button style={iconBtn}>
            <IoIosSearch />
          </button>
          <button style={iconBtn}>
            <PiDotsThreeVertical />
          </button>
        </div>
      </div>

      {/* User List */}
      <div style={{ padding: "10px" }}>
        <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
          {users.map((u) => (
            <div
              key={u.id}
              onClick={() => handleUserClick(u.email)}
              style={{
                display: "flex",
                padding: "8px",
                borderBottom: "1px solid #eee",
                gap: "3rem",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <FaUserTie size={18} />
                <div>
                  <div style={{ fontWeight: "500", fontSize: "18px" }}>
                    {u.name}
                  </div>
                  {u.lastTimestamp > 0 && (
                    <div style={{ fontSize: "12px", color: "#666" }}>
                      {new Date(u.lastTimestamp).toLocaleTimeString()}
                    </div>
                  )}
                </div>
              </div>
              <div style={{ position: "relative" }}>
                <NotificationAddRounded
                  style={{
                    marginLeft: "auto",
                    color: "#1976d2",
                    cursor: "pointer",
                    fontSize: "26px",
                  }}
                />
                {u.unreadCount > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: "-4px",
                      right: "-4px",
                      backgroundColor: "red",
                      color: "white",
                      borderRadius: "50%",
                      padding: "2px 6px",
                      fontSize: "10px",
                      fontWeight: "bold",
                    }}
                  >
                    {u.unreadCount}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const iconBtn = {
  color: "black",
  fontWeight: "bold",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  backgroundColor: "white",
  marginLeft: "10px",
};

export default EmployeeChat;
